import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClientHttpService {
  private baseUrl = environment.api;

  constructor(private httpClient: HttpClient) {}

  public get<T = unknown>(params: {
    path: string;
    options?: {
      params?: HttpParams;
      headers?: HttpHeaders;
      observe?: any;
    };
  }) {
    return this.httpClient.get<T>(
      `${this.baseUrl}/${params.path}`,
      params.options
    );
  }

  public post<T = unknown>(params: {
    path: string;
    body: any;
  }): Observable<any> {
    return this.httpClient.post<T>(
      `${this.baseUrl}/${params.path}`,
      params.body
    );
  }

  public postAuth<T = unknown>(params: {
    path: string;
    token: any;
  }): Observable<any> {
    return this.httpClient.post<T>(
      `${this.baseUrl}/${params.path}`,
      params.token
    );
  }

  public put<T = unknown>(params: {
    path: string;
    body: any;
  }): Observable<any> {
    return this.httpClient.put<T>(
      `${this.baseUrl}/${params.path}`,
      params.body
    );
  }

  public patch<T = unknown>(params: {
    path: string;
    body: any;
  }): Observable<any> {
    return this.httpClient.patch<T>(
      `${this.baseUrl}/${params.path}`,
      params.body
    );
  }

  public delete<T = unknown>(params: {
    path: string;
    options?: {
      params?: HttpParams;
      headers?: HttpHeaders;
    };
  }): Observable<any> {
    return this.httpClient.delete<T>(
      `${this.baseUrl}/${params.path}`,
      params.options
    );
  }
}
